import React, {useEffect, useState} from 'react';
import Frame from "../common/Frame";
import {appdata, save} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import './Price.css';
import {Col, Row} from "react-bootstrap";
import {MotivationBlock} from "../common/MotivationBlock";
import {EventData} from "../common/EventData";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import i18next from "i18next";
import {submitPrice, validatePrice} from "./PricePageLogic";
import {PackagesBlock} from "./PackagesBlock";
import {pingApi} from "../../backend/connectors/JavaConnector";


export function FlexPrice() {
    pingApi().then()
    const { t } = useTranslation();
    const history = useHistory();
    const [price, setPrice] = useState("");
    appdata.header = t(appdata.product.priceHeaderMessage)
    const [priceError, setPriceError] = useState(i18next.t(appdata.product.priceMessage));

    const handleSubmit= (event) => {
        event.preventDefault();
        registerConcersion('AddToWishlist');
        let nextPage = submitPrice(appdata,price)
        save()
        if (nextPage !== undefined)
            history.push(nextPage)
    }
    function validateImpl(val) {
        setPrice(val)
        let res = validatePrice(appdata, val)
        if ("OK" === res.code)
        {
            setPriceError("")
            return true
        }
        setPriceError(t(res.code,res.param))
        return false
    }

    useEffect(() => {
        registerConcersion('Search');
        if (appdata.priceFull !== 0)
            setPrice(appdata.priceFull)
    }, [])


    return (
        <div id = "flexPricePage">
            <Frame>
                <form className="app-form" method="post" id="lead_form" onSubmit={event => handleSubmit(event)}>
                    {(appdata["eventType"] !== "DONATE")?
                    <EventData/>
                    :<div></div>}
                    <br/>
                    <div>
                        <br/>
                        <Row style={ {display: "flex", alignItems: "center"}}>
                            <Col style={{padding:0}}>
                                <div style={{fontSize:26, verticalAlign: "middle"}} className="text-right">
                                    {(appdata["eventType"] !== "DONATE")?
                                        t("TicketPriceEur")
                                        :t("Amount")}

                                </div>
                            </Col>
                            <Col style={{padding:0, fontSize:22}}>
                                    <input
                                        autoFocus
                                        type="number"
                                        name="price"
                                        value={price}
                                        onChange={event => validateImpl(event.target.value)}
                                        style = {{width:130,fontSize:26}}
                                        placeholder={t("PleaseEnterTicketPrice")}
                                        id="price"/>
                            </Col>
                            <Col style={{padding:0}}>
                                <div style={{fontSize:26}} className="text-left">
                                    {appdata.product["currency"]}
                                </div>
                            </Col>

                        </Row>
                        <br/>
                        <div className="text-danger errormessage">{priceError}</div>
                    </div>
                    <br/>
                    <div className="app-button d-flex justify-content-around">
                     <button id="nextButtonPrice" type="submit" className="app-btn app-btn-further next-step-btn">
                         <span>{t("NextButton")}</span>
                     </button>
                 </div>
                 <MotivationBlock/>
                 <PackagesBlock/>
                </form>
            </Frame>
        </div>
    );
}
